import React from "react";
import { IDetailsComposition } from "../../interfaces/IDetails";
import {
  Container,
  Description,
  DetailFrame,
  Info,
  Infos,
  InnerInfo,
  Text,
} from "./styles/Details";

const Details: React.FC & IDetailsComposition = ({
  children,
  ...restProps
}) => <DetailFrame {...restProps}>{children}</DetailFrame>;

Details.Description = function DetailsDescription({ children, ...restProps }) {
  return <Description {...restProps}>{children}</Description>;
};

Details.Text = function DetailsText({ children, ...restProps }) {
  return <Text {...restProps}>{children}</Text>;
};

Details.Container = function DetailsContainer({ children, ...restProps }) {
  return <Container {...restProps}>{children}</Container>;
};

Details.Infos = function DetailsInfos({ children, ...restProps }) {
  return <Infos {...restProps}>{children}</Infos>;
};

Details.Info = function DetailsInfo({ children, ...restProps }) {
  return <Info {...restProps}>{children}</Info>;
};

Details.InnerInfo = function DetailsInnerInfo({ children, ...restProps }) {
  return <InnerInfo {...restProps}>{children}</InnerInfo>;
};

export default Details;
